import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// styles
import './ContactCard.scss';
import '@ingka/hyperlink/style.scss';
import '@ingka/inline-message/style.scss';

import { selectSelectedTopic, selectContactPage } from 'Store/selectors';
import Loading from 'Components/loading/Loading.jsx';
import { ROUTE_ERROR_PAGE } from 'Constants/routes';

import { useGetTopicQuery } from 'Services/api';
import { useGetCustomerServiceContactNumberQuery } from 'Services/api/customerServiceContactNumberApi';
import { useGetStandardOpeningHoursQuery } from 'Services/api/standardOpeningHoursApi';
import { useGetCustomerServiceHolidaysQuery } from 'Services/api/customerServiceHolidaysApi';
import calculateSchedules from 'Utils/calculateSchedules';
import SendValuesToAnalytics from 'Utils/reactAnalytics.jsx';
import StoreOpenOrClosed from './commons/StoreOpenOrClosed.jsx';
import Disclaimer from './commons/Disclaimer.jsx';
import ImageForCard from './commons/ImageForCard.jsx';
import ViewMoreSelector from './commons/ViewMoreSelector.jsx';
import CardDescription from './commons/CardDescription.jsx';
import CardTitle from './commons/CardTitle.jsx';
import ViewOpeningHours from './commons/VieOpeningHours.jsx';
import ContactSelector from './ContactSelector.jsx';

const { PHRASE_TRANSLATIONS } = process.env.REACT_APP_MARKET_VALUES;
const marketLang = process.env.REACT_APP_MARKET_VALUES.CMS_LOCALE_LANGUAGE;

const ContactCard = (props) => {
    const {
        history,
        cardTitle,
        phoneNumbers,
        contactType,
        index,
        recommendedButtonExists,
        contactLabel,
        imgCMS,
        disclaimer,
    } = props;
    const [viewMore, setViewMore] = useState(true);

    const { data: contactNumbers, error: errorCustomerServiceContactNumber } =
        useGetCustomerServiceContactNumberQuery();
    const { data: standardOpeningHours, error: errorStandarOpeningHours } =
        useGetStandardOpeningHoursQuery();
    const { data: holidays, error: errorCustomerServiceHoliday } =
        useGetCustomerServiceHolidaysQuery();
    const { data: pages } = useGetTopicQuery();
    const selectedTopic = useSelector(selectSelectedTopic);
    const selectedContactPage = useSelector(selectContactPage);

    if (
        errorCustomerServiceContactNumber ||
        errorStandarOpeningHours ||
        errorCustomerServiceHoliday
    ) {
        history.push(ROUTE_ERROR_PAGE);
        return null;
    }
    let hoursCMS;
    let afterHoursMessage;
    let storeOpened;

    if (standardOpeningHours && holidays) {
        [hoursCMS, afterHoursMessage, storeOpened] = calculateSchedules(
            standardOpeningHours,
            holidays,
            contactType,
        );
    }

    const cardClass = () => (!imgCMS ? 'cardOverride' : 'card-with-image cardOverride');

    const sendToAnalytics = (component) => {
        const openingHoursText = PHRASE_TRANSLATIONS.openingHours;
        SendValuesToAnalytics({
            pages,
            selectedTopic,
            selectedContactPage,
            contactLabel,
            contactType,
            cardTitle,
            openingHoursText,
            component,
        });
    };
    const handleViewMore = () => {
        sendToAnalytics('ViewOpeningHours');
        setViewMore(!viewMore);
    };
    if (!contactLabel) return null;
    return (
        <>
            <div className={cardClass()} data-cy={`contactcard-${contactType}`}>
                <ImageForCard imageSrc={imgCMS} altValue={PHRASE_TRANSLATIONS.htmlMetatag} />

                <CardTitle props={props} />

                <div className="card__content-block">
                    <CardDescription props={props} />

                    {!standardOpeningHours && <Loading />}
                    {standardOpeningHours && (
                        <>
                            <ContactSelector
                                cms={props}
                                index={recommendedButtonExists ? 1 : index}
                                phoneNumbers={phoneNumbers || contactNumbers?.items}
                                storeOpened={storeOpened}
                                activateAnalytics={() => sendToAnalytics('Button')}
                                PHRASE_TRANSLATIONS={PHRASE_TRANSLATIONS}
                            />
                            {hoursCMS && (
                                <>
                                    <StoreOpenOrClosed
                                        storeOpened={storeOpened}
                                        afterHoursMessage={afterHoursMessage}
                                        title={PHRASE_TRANSLATIONS.inlineMessageHead}
                                        body={PHRASE_TRANSLATIONS.inlineMessageBody}
                                    />
                                    <Disclaimer disclaimerText={disclaimer} />

                                    <ViewMoreSelector
                                        textViewMore={PHRASE_TRANSLATIONS.openingHours}
                                        onClick={() => handleViewMore()}
                                    />
                                    <ViewOpeningHours
                                        showHours={!viewMore}
                                        hoursCMS={hoursCMS}
                                        PHRASE_TRANSLATIONS={PHRASE_TRANSLATIONS}
                                        marketLang={marketLang}
                                    />
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
            <div className="separator" />
        </>
    );
};

ContactCard.propTypes = {
    cardTitle: PropTypes.string,
    imgCMS: PropTypes.string,
    contactType: PropTypes.string,
    contactLabel: PropTypes.string,
    index: PropTypes.number,
    recommendedButtonExists: PropTypes.bool,
    disclaimer: PropTypes.string,
    phoneNumbers:
        PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                phoneNumber: PropTypes.string,
                identifier: PropTypes.string,
                createdAt: PropTypes.string,
                entityName: PropTypes.string,
                updatedAt: PropTypes.string,
            }),
        ) || Boolean,
    history: PropTypes.object,
};

export default withRouter(ContactCard);
